import React, {useState} from 'react'
import logo from '../img/logo.svg'
import axiosClient from '../utils/API'
import swal from 'sweetalert'

const Reset = () => {
  const [email, setEmail] = useState('')
  const [errorMsg, setErrorMsg] = useState(null)

  async function handleResetPassword(e) {
    console.log(email)
    e.preventDefault()
    try {
      const response = await axiosClient.post('/forgot-password', {
        email,
      })
      console.log(response)
      swal('Se ha enviado un correo de recuperación a tu cuenta', '', 'success')
      setErrorMsg(null)
    } catch (error) {
      setErrorMsg(error.response.data.error)
    }
  }

  return (
    <body
      className="page home page-template-default"
      style={{margin: '3rem 0'}}
    >
      <div id="page" className="hfeed site">
        <a className="skip-link screen-reader-text" href="#site-navigation">
          Skip to navigation
        </a>
        <a className="skip-link screen-reader-text" href="#content">
          Skip to content
        </a>

        <div id="content" className="site-content" tabindex="-1">
          <div className="container">
            <nav className="woocommerce-breadcrumb">
              <a href="#"></a>
              <span className="delimiter"></span>
            </nav>

            <div id="primary" className="content-area">
              <main id="main" className="site-main">
                <article id="post-8" className="hentry">
                  <div className="entry-content">
                    <div className="woocommerce">
                      <div className="customer-login-form">
                        <span className="or-text"></span>

                        <div className="col2-set" id="customer_login">
                          <div className="col-12 col-sm-8 col-md-12 col-lg-5">
                            <h2>Recuperar contraseña</h2>
                            <form onSubmit={e => handleResetPassword(e)}>
                              <label for="username">
                                Correo<span className="required">*</span>
                              </label>
                              <input
                                type="email"
                                className="input-text"
                                name="email"
                                id="email"
                                onChange={e => setEmail(e.target.value)}
                              />
                              {errorMsg !== null ? (
                                <span className="btn_alert_error_msg">
                                  {errorMsg}{' '}
                                </span>
                              ) : null}

                              <input
                                type="submit"
                                style={{marginTop: '1rem', color: 'white'}}
                                value="Recuperar contraseña"
                              />
                            </form>
                          </div>

                          <div className="col-2"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              </main>
            </div>
          </div>
        </div>
      </div>
    </body>
  )
}

export default Reset
